import { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FinanceTabs, FinanceHeader, money } from "./financeShell";

export default function Payments() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/finance/payments").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  const total = items ? items.reduce((s, p) => s + (p.amount || 0), 0) : 0;

  return (
    <div className="p-6 max-w-[1400px] mx-auto space-y-5" data-testid="finance-payments">
      <FinanceHeader title="Payments" subtitle="Every payment recorded against firm invoices." />
      <FinanceTabs user={user} />

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 inline-block" data-testid="pay-total">
        <div className="text-xs text-slate-500">Total Recorded</div>
        <div className="text-2xl font-bold text-emerald-600 mt-1">{money(total)}</div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-x-auto">
        <table className="w-full text-sm whitespace-nowrap" data-testid="pay-table">
          <thead><tr className="text-left text-xs text-slate-400 border-b border-slate-100">
            {["Date", "Client", "Invoice", "Method", "Reference", "Amount", "Recorded By"].map((h) => <th key={h} className="px-3 py-2.5 font-medium">{h}</th>)}
          </tr></thead>
          <tbody>
            {items === null ? <tr><td colSpan={7} className="px-5 py-12 text-center"><Icons.Loader2 className="h-5 w-5 animate-spin text-[#F5A623] inline" /></td></tr> :
            items.length === 0 ? <tr><td colSpan={7} className="px-5 py-12 text-center text-slate-400">No payments recorded yet.</td></tr> :
            items.map((p) => (
              <tr key={p.id} data-testid={`pay-row-${p.id}`} className="border-b border-slate-50 hover:bg-slate-50">
                <td className="px-3 py-2.5 text-slate-600">{(p.received_date || p.created_at || "").slice(0, 10)}</td>
                <td className="px-3 py-2.5 font-medium text-slate-800">{p.client_name || "—"}</td>
                <td className="px-3 py-2.5 font-mono text-xs text-slate-600">{p.invoice_number}</td>
                <td className="px-3 py-2.5 capitalize text-slate-600">{(p.method || "").replace(/_/g, " ")}</td>
                <td className="px-3 py-2.5 text-slate-500">{p.reference_number || "—"}</td>
                <td className="px-3 py-2.5 font-semibold text-emerald-600">{money(p.amount, p.currency)}</td>
                <td className="px-3 py-2.5 text-slate-500">{p.recorded_by_name || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
